import React from 'react'
import { useToggle } from 'react-use'

import { IconButton } from '~/components/elements/IconButton'

import { SortDialog, type SortDialogProps } from './components/SortDialog'

export type SortButtonProps<ColumnKey extends string> = Omit<
  SortDialogProps<ColumnKey>,
  'onClose'
>

export const SortButton = <ColumnKey extends string>({
  items,
  onChange,
  value,
}: SortButtonProps<ColumnKey>) => {
  const [visibleDialog, toggleVisibleDialog] = useToggle(false)

  return (
    <>
      <IconButton
        fillMode="outline"
        icon="sort-desc"
        onClick={toggleVisibleDialog}
      />

      {visibleDialog && (
        <SortDialog
          items={items}
          value={value}
          onChange={onChange}
          onClose={toggleVisibleDialog}
        />
      )}
    </>
  )
}
